const locale = {
  placeholder: 'Оберіть час',
};

export default locale;
